import { Stack, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { Link } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { UserContext } from "components/context/UserProvider";
import { toQueryString } from "components/hooks/useQueryStringState";
import ListShort from "components/ui/atoms/ListShort";
import DealListItemShort from "models/deals/DealListItemShort";
import { useAllDeal } from "models/deals/apiDeal";
import { useModal } from "@ebay/nice-modal-react";
import { useNavigate } from "react-router-dom";

const defaultFilter = {
  committee_state: [
    "NEW_DEALS",
    "CURRENT_DEALS",
    "INVESTMENT_DEALS",
    "EXITED_DEALS",
  ],
};

const DealWidget = ({ userId }) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const [state, setState] = useState({
    filter: {
      ...defaultFilter,
      owners: userId,
      offset: 0,
    },
  });
  const [fetchParams, setFetchParams] = useState(null);
  const { data: dealList, status, refetch } = useAllDeal(fetchParams);
  const { countDeal } = useContext(UserContext);
  const dealModal = useModal("DealDrawer");

  useEffect(
    () =>
      setFetchParams({
        ...defaultFilter,
        ...state.filter,
        ordering: "investment_status",
        offset: state.offset,
      }),
    [state],
  );
  const handleClick = (deal) => {
    return navigate(
      `/company/${deal.company_detail.id}${toQueryString({
        dealsAndSourcings: `Deal-${deal.id}`,
      })}`,
    );
  };
  return (
    <>
      <ListShort
        title={
          <Stack spacing={1} alignItems="center" direction="row">
            <Typography variant="subtitle2">
              <Link
                style={{ textDecoration: "none", color: "inherit" }}
                to={"/deal"}
                //pathname: "/deal",
                //query: toQuery(state),
                //}}
              >
                Deals
              </Link>
            </Typography>
            <Typography
              variant="subtitle2"
              sx={{
                backgroundColor: theme.palette_custom.yellow,
                borderRadius: "50%",
                width: "1rem",
                height: "1rem",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              {countDeal &&
                countDeal.ACTIVE_DUE_DILL +
                  countDeal.INBOX_COMMITTEE +
                  countDeal.INVESTMENT +
                  countDeal.TO_CLOSE}
            </Typography>
          </Stack>
        }
        emptyMessage="No Deals"
        resource={dealList}
        resourceStatus={status}
        addResource={() =>
          dealModal
            .show({
              formType: "create",
              initialValues: {
                deal_owner: userId,
              },
            })
            .then(() => {
              refetch();
            })
        }
        state={state}
        setState={setState}
        ListItemComponent={DealListItemShort}
        primaryClick={handleClick}
        pagination
      />
    </>
  );
};

export default DealWidget;
